var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDevice17({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 930.3 930.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Degradado_sin_nombre_230);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        opacity: .19;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #252525;\r\n      }\r\n\r\n      .cls-6 {\r\n        mask: url(#mask-1);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #b4afac;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #e5e3e3;\r\n      }\r\n\r\n      .cls-9 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#Degradado_sin_nombre_295);\r\n      }\r\n\r\n      .cls-11 {\r\n        filter: url(#luminosity-noclip-2);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-13 {\r\n        mask: url(#mask-2);\r\n      }\r\n\r\n      .cls-14 {\r\n        filter: url(#luminosity-noclip-3);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6a84ff;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Degradado_sin_nombre_253);\r\n        opacity: .14;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #444;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Degradado_sin_nombre_223);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Degradado_sin_nombre_282);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #b4b4b4;\r\n      }\r\n\r\n      .cls-19 {\r\n        opacity: .26;\r\n      }\r\n\r\n      .cls-20 {\r\n        opacity: .64;\r\n      }\r\n\r\n      .cls-21 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Degradado_sin_nombre_239);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #adadad;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#Degradado_sin_nombre_300);\r\n        opacity: .47;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #eeeded;\r\n      }\r\n\r\n      .cls-25 {\r\n        filter: url(#luminosity-noclip);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_300",
    "data-name": "Degradado sin nombre 300",
    x1: 162,
    y1: 805.49,
    x2: 71.55,
    y2: 564.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adadad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6a6a6a",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 90.79,
    y: 594.19,
    width: 42,
    height: 21,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 90.79,
    y: 594.19,
    width: 42,
    height: 21,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 21,
    transform: "translate(90.79 594.19)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAVCAYAAAAw73wjAAAACXBIWXMAAAsSAAALEgHS3X78AAAChElEQVRIidXXQUvycBzA8e/2n8W/ydZKkZIMQUvxMMI6desldOgt+AY6dnguHYKI6NClF9Bdj70CwS5K3SqIKMRAzKRDrnUI/1jZUz70NPqCbLINPrr92KYBPr8gPWjAV1PQeDwepOPTFDSTybCyshKk5a8ZvZVkMsnMzAyxWIzDw8MgTQNT0KmpKfL5PK7rEovF2N3dDdL1LgW1bZtMJoPjOESjUXRdZ2dnJ0jbqxRUSonjOExMTJDP5zFNEyklm5ubQfpURv8XXX+ZrdHRUVzXxfd9ut0uW1tbgeD6U9Bms0mz2WR8fFxtdF0Xy7LI5XJUKhX29vYCQQII4A/A9PQ0iUQCx3GQUgKgaRqO45BKpUin0ywsLBCPx6lUKsFBq9UqpmnSarUYGxsjEomonUZGRohGoySTSXK5HEtLS8zOzlIul38MqjHgXr+xscHa2hrZbBbDMN4d1Ol0uLq6olarUa/XOT09ZX9//+ehAOvr66yurjI3N8fk5OTAgz3P4/7+nuvra87Ozuh0Onieh+/7PD09DQXxfV8N78PDA/V6nWq1SrFYBN5MfX/b29u0220WFxdZXl4mkUhgmuarfYQQ2LaNbdtks1kABfT94R7K+qF3d3dcXFzQ7XYVVF2jgzo+PqZUKmEYBre3twgh0HUdIcTASwJeBlDTNHRdH/ojhCAUChEOhwE4Pz/n6Ojoc2ivcrlMsVjE8zxubm5oNBqvQL3ld9ZqtTg5OVHQD0/9oA4ODtR6oVBgfn4ey7KQUhIOh0mlUkQiEaSUhEIh9WO+Uu/UPz4+0m63uby8pNFoqO0fDtO/VCgUSKfTWJaFYRjq3x4G+naYSqXS90P/Z7/mVeQZOsXjbfKR96IAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_282",
    "data-name": "Degradado sin nombre 282",
    x1: 116.22,
    y1: 593.58,
    x2: 99.61,
    y2: 635.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_253",
    "data-name": "Degradado sin nombre 253",
    x1: 125.42,
    y1: 774.87,
    x2: 580.88,
    y2: 774.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adadad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a0a0a0",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#7d7d7d",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_223",
    "data-name": "Degradado sin nombre 223",
    x1: 719.96,
    y1: 718.35,
    x2: 719.64,
    y2: 608.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adadad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6c6c6c",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_239",
    "data-name": "Degradado sin nombre 239",
    x1: 736.49,
    y1: 685.24,
    x2: 677.71,
    y2: 591.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adadad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9b9b9b",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6c6c6c",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_230",
    "data-name": "Degradado sin nombre 230",
    x1: 691.73,
    y1: 717.12,
    x2: 672.17,
    y2: 599.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#adadad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#747474",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 504.79,
    y: 721.19,
    width: 98,
    height: 137,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 504.79,
    y: 721.19,
    width: 98,
    height: 137,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("image", {
    width: 98,
    height: 137,
    transform: "translate(504.79 721.19)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_295",
    "data-name": "Degradado sin nombre 295",
    x1: 577.57,
    y1: 772.2,
    x2: 538,
    y2: 801.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 119.79,
    y: 606.19,
    width: 421,
    height: 158,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 119.79,
    y: 606.19,
    width: 421,
    height: 158,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 421,
    height: 158,
    transform: "translate(119.79 606.19)",
    xlinkHref: "data:image/png;base64,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"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_Icons",
    "data-name": "01_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.58,716.49v-108.16h-8.16v202.5c0,5.05,2.41,9.54,6.14,12.38-1.19-.92-2.24-2-3.13-3.21l45.28-96.68c-3.77-5.89-25.25-15.19-40.12-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M130.58,716.49v-108.16h-8.16v202.5c0,5.05,2.41,9.54,6.14,12.38-1.19-.92-2.24-2-3.13-3.21l45.28-96.68c-3.77-5.89-25.25-15.19-40.12-6.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M130.58,608.33v4.61h-16.5c-8.28,0-15.78-3.39-21.19-8.85v-7.33c4.49,6.95,12.32,11.57,21.19,11.57h16.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    width: 930.3,
    height: 930.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M600.42,855.94H138c-24.91,0-45.11-20.2-45.11-45.12v-214.06c4.49,6.95,12.32,11.57,21.19,11.57h8.33v202.49c0,5.05,2.41,9.54,6.14,12.38.47.37.97.71,1.49,1.01.26.16.53.3.79.44.26.14.53.27.79.39,0,0,.02,0,.03.02.24.1.49.21.75.3.07.03.16.06.24.09.78.29,1.61.52,2.45.67.37.07.74.13,1.12.17.2.03.41.06.61.06.39.03.78.05,1.18.05h442.89l19.53,29.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M580.88,826.42H138c-.4,0-.79-.02-1.18-.05-.2-.02-.41-.04-.61-.06-.38-.04-.75-.09-1.12-.17-.85-.16-1.66-.39-2.45-.67-.08-.03-.17-.06-.24-.09-.25-.1-.5-.2-.75-.3,0,0-.02-.02-.03-.02-.27-.12-.54-.25-.79-.39-.27-.14-.54-.29-.79-.44-.52-.31-1.01-.66-1.49-1.01-1.19-.92-2.24-2-3.13-3.21l45.28-96.68h341.95l68.23,103.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M174.92,822.48c-2.58,0-4.68-2.1-4.68-4.68v-.05l11.32-48.8c.03-2.56,2.12-4.63,4.68-4.63h209.65c2.58,0,4.68,2.1,4.68,4.68l-4.22,48.84c0,2.54-2.1,4.64-4.68,4.64h-216.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M391.67,822.02h-216.75c-2.33,0-4.22-1.89-4.22-4.22l11.32-48.8c0-2.33,1.89-4.22,4.22-4.22h209.65c2.33,0,4.22,1.89,4.22,4.22l-4.22,48.8c0,2.33-1.89,4.22-4.22,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M580.88,826.42H138c-.4,0-.79-.02-1.18-.05-.2-.02-.41-.04-.61-.06-.38-.04-.75-.09-1.12-.17-.85-.16-1.66-.39-2.45-.67-.08-.03-.17-.06-.24-.09-.25-.1-.5-.2-.75-.3,0,0-.02-.02-.03-.02-.27-.12-.54-.25-.79-.39-.27-.14-.54-.29-.79-.44-.52-.31-1.01-.66-1.49-1.01-1.19-.92-2.24-2-3.13-3.21l45.28-96.68h341.95l68.23,103.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M624.71,872.15c-8.49,0-16.36-4.23-21.05-11.31l-160.69-242.85c-4-6.05-10.72-9.66-17.98-9.66H114.09c-13.92,0-25.24-11.32-25.24-25.24V83.39c0-13.92,11.32-25.24,25.24-25.24h702.12c13.92,0,25.24,11.32,25.24,25.24v763.52c0,13.92-11.32,25.24-25.24,25.24h-191.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M816.21,59.99H114.09c-12.92,0-23.4,10.48-23.4,23.4v499.7c0,12.92,10.48,23.4,23.4,23.4h310.9c7.85,0,15.18,3.94,19.51,10.49l160.69,242.85c4.33,6.55,11.66,10.49,19.51,10.49h191.5c12.92,0,23.4-10.48,23.4-23.4V83.39c0-12.92-10.48-23.4-23.4-23.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.44-54.3h467.41c10.53,0,19.09,8.55,19.09,19.09v703.36c0,10.53-8.55,19.09-19.09,19.09H231.44c-10.53,0-19.09-8.55-19.09-19.09V-35.21c0-10.53,8.55-19.09,19.09-19.09Z",
    transform: "translate(781.62 -148.68) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.66,
    y: 165.52,
    width: 669.69,
    height: 377.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 140.63,
    y: 91.08,
    width: 222.99,
    height: 16.65,
    rx: 8.32,
    ry: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 572.41,
    y: 91.08,
    width: 222.99,
    height: 16.65,
    rx: 8.32,
    ry: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.88,
    y: 67.37,
    width: 164.3,
    height: 74.59,
    rx: 1.83,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 406.14,
    y: 88.26,
    width: 10.95,
    height: 21.2,
    rx: 5.48,
    ry: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 520.46,
    y: 88.26,
    width: 10.95,
    height: 21.2,
    rx: 5.48,
    ry: 5.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 489.94,
    cy: 100.09,
    r: 15.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 489.94,
    cy: 100.09,
    r: 5.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 449.31,
    cy: 100.09,
    r: 15.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 449.31,
    cy: 100.09,
    r: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M655.24,595.5h129.09c7.01,0,12.71,5.7,12.71,12.71v101.13c0,7.01-5.7,12.71-12.71,12.71h-129.09c-7.02,0-12.71-5.7-12.71-12.71v-101.13c0-7.01,5.7-12.71,12.71-12.71Z",
    transform: "translate(1378.56 -61.01) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 656.97,
    y: 581.98,
    width: 125.63,
    height: 153.58,
    rx: 12.25,
    ry: 12.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M761.48,602.29v112.97c0,1.16-.21,2.27-.61,3.29l-8.58-83.87c0-3.87-3.14-7-6.99-7h-51.03c-3.86,0-6.99,3.14-6.99,7l-8.58,83.87c-.4-1.02-.61-2.13-.61-3.29v-112.97c0-5.1,4.13-9.24,9.24-9.24h64.92c5.1,0,9.24,4.13,9.24,9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.87,718.56c-1.32,3.48-4.69,5.94-8.63,5.94h-64.92c-3.94,0-7.31-2.46-8.63-5.94l8.58-83.87c0-3.87,3.14-7,6.99-7h51.03c3.86,0,6.99,3.14,6.99,7l8.58,83.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M761.48,724.5h-83.39l.61-5.94,8.58-83.87c0-3.87,3.14-7,6.99-7h51.03c3.86,0,6.99,3.14,6.99,7l8.58,83.87.61,5.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 692.7,
    y: 636.01,
    width: 54.18,
    height: 69.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.79,
    y: 648.88,
    width: 33.98,
    height: 43.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M761.48,602.29v112.97c0,1.16-.21,2.27-.61,3.29l-8.58-83.87c0-3.87-3.14-7-6.99-7h-51.03c-3.86,0-6.99,3.14-6.99,7l-8.58,83.87c-.4-1.02-.61-2.13-.61-3.29v-112.97c0-5.1,4.13-9.24,9.24-9.24h64.92c5.1,0,9.24,4.13,9.24,9.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.9,596.81c-1.13,1.53-1.81,3.43-1.81,5.48v112.97c0,1.16.21,2.27.61,3.29l8.58-83.87c0-2.47,1.29-4.63,3.22-5.87l-10.6-32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "600.42 855.94 594.88 855.94 507.13 723.32 512.66 723.32 537.91 761.48 580.88 826.42 600.42 855.94"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.5,761.48h396.41l-25.25-38.16H170.7c-3.77-5.89-25.25-15.19-40.12-6.83v-108.16h-8.16v134.07c0,10.54,8.54,19.09,19.09,19.09Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevice17);
export default __webpack_public_path__ + "static/media/ic-device-17.6b52e6df84fa4855d43baef34b5ebfb0.svg";
export { ForwardRef as ReactComponent };